import { initializeApp } from 'firebase/app';
import { initializeFirestore, connectFirestoreEmulator, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getAuth, connectAuthEmulator, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { getAnalytics, logEvent, isSupported as isAnalyticsSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyCt4Z-vzAb7DaeJcoU7jNo_coyGRrOJTrA",
  authDomain: "playfm-chat.firebaseapp.com",
  projectId: "playfm-chat",
  storageBucket: "playfm-chat.firebasestorage.app",
  messagingSenderId: "602638450150",
  appId: "1:602638450150:web:8b73b7f71f8f142f4b2a27",
  measurementId: "G-V1BK07NLPY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with improved settings for better connectivity and modern cache configuration
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  ignoreUndefinedProperties: true,
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
    cacheSizeBytes: 50 * 1024 * 1024 // 50MB cache
  })
});

console.log('Firestore initialized with persistent cache');

// Initialize Auth with persistence
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Auth persistence set to local successfully');
  })
  .catch((error) => {
    console.error('Error setting auth persistence:', error);
  });

// Initialize Firebase Cloud Messaging only if supported
let messaging: any = null;
isSupported().then(supported => {
  if (supported) {
    messaging = getMessaging(app);
    console.log('Firebase Cloud Messaging initialized');
  } else {
    console.log('Firebase Cloud Messaging is not supported in this browser');
  }
}).catch(error => {
  console.error('Error checking Firebase Cloud Messaging support:', error);
});

// Initialize Firebase Analytics only if supported and in browser environment
let analytics: any = null;
if (typeof window !== 'undefined') {
  isAnalyticsSupported().then(supported => {
    if (supported) {
      analytics = getAnalytics(app);
      console.log('Firebase Analytics initialized');
    } else {
      console.log('Firebase Analytics is not supported in this browser');
    }
  }).catch(error => {
    console.error('Error checking Firebase Analytics support:', error);
  });
}

// Add connection status monitoring
let isOnline = navigator.onLine;
const updateOnlineStatus = () => {
  isOnline = navigator.onLine;
  console.log('Network status changed:', isOnline ? 'Online' : 'Offline');
};

window.addEventListener('online', updateOnlineStatus);
window.addEventListener('offline', updateOnlineStatus);

// Export connection status
export const getConnectionStatus = () => isOnline;

export { app, db, auth, messaging, analytics, getToken, onMessage, logEvent };